import LoginLogo from './login-logo';

export default LoginLogo;
